// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_2f55z","locked":"index_locked_3Da97"};